import { render, staticRenderFns } from "./secondary-button.vue?vue&type=template&id=d427fce2&scoped=true&"
import script from "./secondary-button.vue?vue&type=script&lang=js&"
export * from "./secondary-button.vue?vue&type=script&lang=js&"
import style0 from "./secondary-button.vue?vue&type=style&index=0&id=d427fce2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d427fce2",
  null
  
)

export default component.exports